import { HttpMethod, initFetch } from "../../utils/fetcher";

export const SAVE_SUCCESS_NOTES = "SAVE_SUCCESS_NOTES";
export const SAVE_FAIL_NOTES = "SAVE_FAIL_NOTES";
export const UPDATE_SUCCESS_NOTES = "UPDATE_SUCCESS_NOTES";
export const UPDATE_FAIL_NOTES = "UPDATE_FAIL_NOTES";
export const DELETE_SUCCESS_NOTES = "DELETE_SUCCESS_NOTES";
export const DELETE_FAIL_NOTES = "DELETE_FAIL_NOTES";

export function saveNote(jsonData) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`notes`, HttpMethod.POST);
      // make async call to database
      fetch(url, { ...params, body: JSON.stringify(jsonData) })
        .then((res) => res.json())
        .then((res) => {
          resolve(res.note);
          dispatch({
            type: SAVE_SUCCESS_NOTES,
            payload: res.note,
          });
        })
        .catch((err) => {
          dispatch({
            type: SAVE_FAIL_NOTES,
            error: err,
          });
        });
    });
  };
}

export function updateNote(jsonData, id) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`notes/${id}`, HttpMethod.PUT);
      // make async call to database
      fetch(url, { ...params, body: JSON.stringify(jsonData) })
        .then((res) => res.json())
        .then((res) => {
          resolve(res.note);
          dispatch({
            type: UPDATE_SUCCESS_NOTES,
            payload: res.note,
            id: id,
          });
        })
        .catch((err) =>
          dispatch({
            type: UPDATE_FAIL_NOTES,
            error: err,
          })
        );
    });
  };
}

export function deleteNote(id) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`notes/${id}`, HttpMethod.DELETE);
      // make async call to database
      fetch(url, params)
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw new Error("500");
          }
        })
        .then((res) => {
          resolve(res.note);
          dispatch({
            type: DELETE_SUCCESS_NOTES,
            payload: res.note,
            id: id,
          });
        })
        .catch((err) => {
          reject(err);
          dispatch({
            type: DELETE_FAIL_NOTES,
            error: err,
          });
        });
    });
  };
}
